













import Vue from 'vue'
import moment from 'moment/moment'
import config from '@/utils/config'
import request from '@/utils/request'
// @ts-ignore
import skyconText from '@/utils/skyconText.js'
import ForecastData from '@/service/ForecastData'
import gridFormat from "@/utils/gridFormat";
const formatWeekDay = (datetime: moment.Moment) => {
  const day = datetime.day()
  const s = ['日', '一', '二', '三', '四', '五', '六']
  return '周' + s[day]
}
export default Vue.extend({
  props: ['longitude', 'latitude'],
  computed: {
    lngLat(): any {
      const { longitude, latitude } = this
      return { longitude, latitude }
    },
  },
  watch: {
    lngLat() {
      this.getData()
    },
  },
  data() {
    return {
      data: {},
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      const grid12hours = await ForecastData.get12hours(this.lngLat.latitude, this.lngLat.longitude)
      console.log(grid12hours)
      const gridDaily = await ForecastData.getDaily(this.lngLat.latitude, this.lngLat.longitude)


      if (!gridDaily || gridDaily.length == 0) return []
      const qiBaoTime = moment(gridDaily[0].dataTime, 'YYYYMMDDHHmmss').hour()
      let hourSub = 0 // 小时差值，若是8点起报的数据，应将时间减24小时
      if (qiBaoTime === 8) hourSub = 24
      const dataTmp = []
      for (let i = 0; i < gridDaily.length; i++) {
        if (qiBaoTime === 8 && i == 0) continue // 8点起报数据不显示当天预报
        if (dataTmp.length >= 7) break // 只展示7天数据
        const t = gridDaily[i]
        const dt = moment(t.dataTime, 'YYYYMMDDHHmmss').subtract(hourSub, 'h')
        const { wp12 } = grid12hours[i * 2 + (qiBaoTime === 8 ? 0 : 1)]
        dataTmp.push({
          week: formatWeekDay(dt),
          date: dt.format('MM/DD'),
          wpimg: gridFormat.formatSkyConIcon(wp12),
          wpdesc: gridFormat.formatWeather(wp12),
          tmin24: t.tmin24.toFixed(0),
          tmax24: t.tmax24.toFixed(0),
        })
      }
      this.data = dataTmp
      console.log(this.data)

    },
    getSkyCon(wp: number) {
      return gridFormat.formatSkyConIcon(wp)
    },
    getDesc(wp: number) {
      return gridFormat.formatWeather(wp)
    }

    // getData() {
    //     const url = `/v2.5/0woAfhHWQi4n5X9N/${this.lngLat.longitude},${this.lngLat.latitude}/daily`
    //     request.get(url).then((result) => {
    //         // console.log(result.result.daily)
    //         const tempData = result.result.daily.temperature
    //         const skycon = result.result.daily.skycon
    //         const daysData = skycon.map((e: any) => {
    //             return {
    //                 imgUrl: `/static/weatherIcon/${e.value}.png`,
    //                 date: e.date.split('T')[0].split('-').slice(1, 3).join('/'),
    //             }
    //         })
    //         daysData.map((e: any) => {
    //             tempData.map((k: any) => {
    //                 if (e.date === k.date.split('T')[0].split('-').slice(1, 3).join('/')) {
    //                     e.min = (k.min).toFixed(0)
    //                     e.max = (k.max).toFixed(0)
    //                 }
    //             })
    //         })
    //         // console.log(daysData)
    //         this.data = daysData
    //     }).catch((err) => {
    //         console.log(err)
    //         this.$Message.warning(err)
    //     })
    // },
  },
})
